export type StakeTranslations = {
  assets: string;
  seeAll: string;
  youEarned: string;
  autoStake: string;
  autoStakingTitle: string;
  autoStakingBoxDescription: string;
  stakingOverviewTitle: string;
  stakeMoreAssets: string;
  almostThere: string;
  autoStakingDrawerDescription: string;
  unstakingAssetsDaysInfo: string;
  stakeFrameBoxTitle: string;
  stakeNow: string;
  yourAssets: string;
  perYear: string;
  previouslyStaked: string;
  otherAssets: string;
  summary: string;
  youUnstaking: string;
  stakingFunds: string;
  availableFunds: string;
  fundsAvailable: string;
  unstakeNow: string;
  estimatedRewards: string;
  firstRewardPayout: string;
  rewardsPayoutInterval: string;
  expectedNextReward: string;
  viewDetails: string;
  tryAgain: string;
  okGoToPortfolio: string;
  stakeFailedTitle: string;
  stakeFailedSubtitle: string;
  unstakeFailedTitle: string;
  unstakeFailedSubtitle: string;
  weekly: string;
  monthly: string;
  poweredByBpfs: string;
  okGotItButton: string;
  approx: string;
  afterFees: string;
  yourTotalStakedAmount: string;
  addedToYourCurrentAssetCountEarnings: string;
  estimatedYearlyRewards: string;
  stakeFrameBoxDesEarn: string;
  amount: string;
  yourStakingRewards: string;
  unstake: string;
  stakeMore: string;
  payoutDate: string;
  unstakingStartedAt: string;
  lastPayout: string;
  nowUnstaking: string;
  rewardsPayout: string;
  nowStaking: string;
  lastMonthLabel: string;
  slashYear: string;
  totalRewards: string;
  noPlanYet: string;
  checkEarnings: string;
  noCurrentStakingAssets: string; // No currently staked assets
  amountAvailable: string; // {{amount}} available
  currentlyStaking: string; // Currently staking
  pastStakings: string; // Past stakings
  stakeFundsAvailable: string; // Stacking funds
  today: string; // Today
};

const tradeScreenTranslations: StakeTranslations = {
  assets: 'assets',
  seeAll: 'see_all',
  youEarned: 'you_earned',
  autoStakingTitle: 'auto_staking_title',
  autoStake: 'auto_stake',
  autoStakingBoxDescription: 'auto_staking_box_description_@tenant',
  stakingOverviewTitle: 'staking_overview_title',
  stakeMoreAssets: 'stake_more_assets',
  almostThere: 'corp_onboarding_email_q_title',
  autoStakingDrawerDescription: 'auto_staking_drawer_description',
  unstakingAssetsDaysInfo: 'unstaking_assets_days_info',
  stakeFrameBoxTitle: 'stake_frame_box_title',
  stakeNow: 'stake_now',
  yourAssets: 'your_assets',
  perYear: 'per_year',
  previouslyStaked: 'previously_staked',
  otherAssets: 'other_assets',
  summary: 'summary',
  estimatedRewards: 'estimated_rewards_@tenant',
  firstRewardPayout: 'first_reward_payout_@tenant',
  youUnstaking: 'you_unstaking',
  rewardsPayoutInterval: 'rewards_payout_interval_@tenant',
  expectedNextReward: 'expected_next_reward_@tenant',
  stakingFunds: 'staking_funds',
  availableFunds: 'available_funds',
  fundsAvailable: 'funds_available',
  unstakeNow: 'unstake_now',
  viewDetails: 'view_details',
  tryAgain: 'try_again',
  okGoToPortfolio: 'ok_go_to_portfolio',
  stakeFailedTitle: 'stake_failed_title',
  stakeFailedSubtitle: 'stake_failed_subtitle',
  unstakeFailedTitle: 'unstake_failed_title',
  unstakeFailedSubtitle: 'unstake_failed_subtitle',
  weekly: 'weekly',
  monthly: 'monthly',
  poweredByBpfs: 'powered_by_bpfs',
  okGotItButton: 'ok_got_it_button',
  approx: 'approx',
  afterFees: 'after_fees',
  yourTotalStakedAmount: 'your_total_staked_amount',
  addedToYourCurrentAssetCountEarnings:
    'added_to_your_current_asset_count_earnings',
  estimatedYearlyRewards: 'estimated_yearly_rewards_@tenant',
  stakeFrameBoxDesEarn: 'stake_frame_box_des_earn',
  amount: 'amount',
  yourStakingRewards: 'your_staking_rewards_@tenant',
  unstake: 'unstake',
  stakeMore: 'stake_more',
  payoutDate: 'payout_date',
  unstakingStartedAt: 'unstaking_started_at',
  lastPayout: 'last_payout',
  nowUnstaking: 'now_unstaking',
  rewardsPayout: 'rewards_payout_@tenant',
  nowStaking: 'now_staking',
  lastMonthLabel: 'last_month_label',
  slashYear: 'slash_year',
  totalRewards: 'total_rewards_@tenant',
  noPlanYet: 'no_plan_yet',
  checkEarnings: 'check_earnings',
  noCurrentStakingAssets: 'no_current_staking_assets',
  amountAvailable: 'amount_available',
  currentlyStaking: 'currently_staking',
  pastStakings: 'past stakings',
  stakeFundsAvailable: 'stake_funds_available',
  today: 'today',
};

export const getStakeTranslations = (
  transUtil: (param: string) => string,
): StakeTranslations => {
  return Object.entries(tradeScreenTranslations).reduce((acc, [key, value]) => {
    acc[key as keyof StakeTranslations] = transUtil(value);

    return acc;
  }, {} as StakeTranslations);
};
